import { ActionTree, MutationTree, GetterTree } from 'vuex';
import { DictionariesApi } from '@/api/DictionariesApi';
import { find } from 'lodash';

const state = {
   items: [],
   colors: [],
   paymentColors: [],
   room_types: [],
   invoice_states: [],
   guides: [],
   agents: [],
   rooms: [],
   drivers: [],
   beneficiaries: [],
   services: [],
   currencies: [],
   vat: [],
   tariffication: [],
   tasks_list: [],
   tasksListsTriggers: [],
   time_of_year: [],
   type_of_activity: [],
   type_of_transfer: [],
   months: [],
   suitable_for_disable: [],
   weather: [],
   constants: [],
};

const mutations: MutationTree<any> = {
   SET_DICTIONARIES(state, dictionaries) {
      state.colors = dictionaries['Status'];
      state.paymentColors = dictionaries['Status Pay'];
      state.room_types = dictionaries['Room type'];
      state.invoice_states = dictionaries['invoice_state'];
      state.services = dictionaries['Service type'];
      state.currencies = dictionaries['currencies'];
      state.vat = dictionaries['VAT types'];
      state.tarification = dictionaries['tariffication'];
      state.tasks_list = dictionaries['Task list'];
      state.tasksListsTriggers = dictionaries["Task's triggers"];

      state.time_of_year = dictionaries['Time of year'];
      state.type_of_activity = dictionaries['Type of activity'];
      state.type_of_transfer = dictionaries['Type of transfer'];
      state.months = dictionaries['Months'];
      state.suitable_for_disable = dictionaries['Suitable for Disable'];
      state.weather = dictionaries['Weather'];
      state.constants = dictionaries['constants'];
   },

   SET_ALL_OBJECTS(state, objects) {
      state.items = objects['activities'];
      state.agents = objects['agents'];
      state.guides = objects['guides'];
      state.rooms = objects['rooms'];
      state.drivers = objects['drivers'];
      state.beneficiaries = objects['beneficiaries'];
   },
};

const getters: GetterTree<any, any> = {
   GP_THRESHOLD(state) {
      return parseFloat(find(state.constants, { d_code: 'GP_THRESHOLD' })?.d_value as string);
   },
};

const actions: ActionTree<any, any> = {
   GET_DICTIONARIES({ commit, state }) {
      return DictionariesApi.dictionaries().then(resp => {
         commit('SET_DICTIONARIES', resp);
         return Object.keys(resp).length;
      });
   },

   GET_ALL_OBJECTS({ commit, state }) {
      return DictionariesApi.allObjects().then(resp => {
         commit('SET_ALL_OBJECTS', resp);
         return Object.keys(resp).length;
      });
   },
};

export default {
   namespaced: true,
   state,
   getters,
   mutations,
   actions,
};
